import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center" data-testid="payment-cancel-page">
      <div className="w-20 h-20 mx-auto rounded-full bg-slate-100 text-slate-500 grid place-items-center">
        <XCircle size={40}/>
      </div>
      <h1 className="mt-6 font-heading text-3xl font-extrabold text-slate-900">Paiement annulé</h1>
      <p className="mt-3 text-slate-600">
        Vous avez annulé la souscription. Aucun montant n'a été prélevé. Vous pouvez réessayer à tout moment.
      </p>
      <div className="mt-6 flex flex-wrap gap-3 justify-center">
        <Link to="/pro/abonnement"><Button className="btn-shine text-white h-11 px-6" data-testid="cancel-retry">Réessayer</Button></Link>
        <Link to="/"><Button variant="outline" className="h-11 px-6">Retour à l'accueil</Button></Link>
      </div>
    </div>
  );
}
